import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiservicesService } from 'src/app/apiservices.service';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-daftar-kemaskini',
  templateUrl: './daftar-kemaskini.component.html',
  styleUrls: ['./daftar-kemaskini.component.css']
})
export class DaftarKemaskiniComponent implements OnInit {

  //UI View Alert Variables
  AlertType:string = "";
  AlertStatus:boolean = false;
  AlertMessage:string = "";

  //UI Status Variables
  LoaderStatus:boolean = false;
  TaxAgentSearchStatus: boolean = false;
  NotTaxAgentSearchStatus: boolean = false;
  IsAgentStatus: boolean = false;

  //UI Input Variables
  IDNoInput: any = "";
  TaxAgentFirmUserEmailInput: any = "";
  TaxAgentFirmUserStatus: boolean = false;
  StaffFirmUserEmailInput: any = "";
  StaffFirmUserStatus: boolean = false;

  //UI View Variables
  IDNoView:any = "";
  FirmIDView:any = "";
  TaxAgentStaffIDView: any = "";
  TaxAgentIDView: any = "";
  TaxAgentIDNoView: any = "";
  TaxAgentNameView: any = "";
  TaxAgentApprovalNo: any = "";
  TaxAgentEmail: any = "";
  TaxAgentCertStartView: any = "";
  TaxAgentCertEndView: any = "";
  TaxAgentPhoneNoView: any = "";
  StaffIDView: any = "";
  StaffIDNoView: any = "";
  StaffNameView: any = "";
  StaffRoleView: any = "";
  StaffOldRoleView: any = "";

  //SessionData
  SessionRoles: any = [];
  SessionStaffIDNo: any = "";
  SessionStaffID: any = "";

  UpdateRole: boolean = false;

  //UI Datatable Variables
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  staffDataSource = new MatTableDataSource();
  taxagentDataSource = new MatTableDataSource();
  displayedStaffColumns = ['name', 'idno', 'role', 'email', 'status','datecreated','action'];
  displayedTaxAgentColumns = ['name', 'idno', 'licenseno', 'certstart', 'certend','status','action'];
  TaxAgentRecordCount: any = "";
  TaxAgentDataTablePageNum: any = 0;
  TaxAgentDataTablePageSize: any = 5;
  StaffRecordCount:any = "";
  StaffDataTablePageNum: any= 0;
  StaffDataTablePageSize: any = 5;

  //Modal Variables
  @ViewChild('agentUpdateCloseButton') agentUpdateCloseButton: any;
  @ViewChild('staffUpdateCloseButton') staffUpdateCloseButton: any;

  constructor(private router: Router, private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.top.updateTotal();
    this.FirmIDView = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionRoles = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffRoles') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionStaffIDNo = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '');
    const Roles = JSON.parse(this.SessionRoles);
    if (Roles.length > 1 && Roles.includes('0201'))
      this.IsAgentStatus = false;
    else if (Roles.length === 1 && Roles.includes('0201'))
      this.IsAgentStatus = false;
    else
      this.IsAgentStatus = true;

    this.GetData("", this.FirmIDView, 0, 5);
    
  }

  paginatorTaxAgentEvent(e: PageEvent, FirmID: any, IDNo: any) {
    this.TaxAgentDataTablePageNum = e.pageIndex;
    this.TaxAgentDataTablePageSize = e.pageSize;
    this.GetDataTaxAgent(IDNo, FirmID, e.pageIndex, e.pageSize);
  }

  paginatorStaffEvent(e: PageEvent, FirmID: any, IDNo: any) {
    this.StaffDataTablePageNum = e.pageIndex;
    this.StaffDataTablePageSize = e.pageSize;
    this.GetDataStaff(IDNo, FirmID, e.pageIndex, e.pageSize);
  }

  Hantar(IDNo:any, FirmID:any){
    this.ResetValue();
    if(IDNo === "" || IDNo === null){
      alert("Sila masukkan no. pengenalan");
      this.GetData("", FirmID, 0, 5);
    }else{
      this.IDNoView = IDNo;
      this.GetData(IDNo, FirmID, 0, 5);
    }
  }

  async GetData(IDNo: any, FirmID: any, PageNum: any, PageSize: any) {
    this.LoaderStatus = true;
    let Params = {};
    if (IDNo === "" || IDNo === null) {
      Params = {
        "FirmID": FirmID,
        "StaffList": true,
        "AgentList": true,
        "OggFilter": true,
        "ActiveIndFilter": true,
        "PageNum": PageNum ?? 0,
        "PageSize": PageSize ?? 5
      }
    } else {
      Params = {
        "FirmID": FirmID,
        "IDNo": IDNo,
        "StaffList": true,
        "AgentList": true,
        "OggFilter": true,
        "ActiveIndFilter": true,
        "PageNum": PageNum ?? 0,
        "PageSize": PageSize ?? 5
      }
    }
    const result = await this.apiServices.GetAllStaff(Params);
    this.TaxAgentRecordCount = result.taxAgent.totalTaxAgent;
    this.StaffRecordCount = result.staff.totalStaff;
    if(this.TaxAgentRecordCount === 0 && this.StaffRecordCount === 0){
      this.AlertType = "fail";
      this.AlertMessage = "Tiada Rekod";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
      this.GetData("", this.FirmIDView, 0, 5);
    } else {
      result.staff.staffRecords.forEach((currentValue: any, index: any) => {
        switch (result.staff.staffRecords[index].role){
          case "0201":
            result.staff.staffRecords[index].role = "Pentadbir";
            break;
          case "0202":
            result.staff.staffRecords[index].role = "Penyelia";
            break;
          case "0203":
            result.staff.staffRecords[index].role = "Staf";
            break;
          default:
            break;
        }
        result.staff.staffRecords[index].firmUserEmail = result.staff.staffRecords[index].firmUserEmail === null ? "N/A" : result.staff.staffRecords[index].firmUserEmail;
        result.staff.staffRecords[index].dateCreated = formatDate(result.staff.staffRecords[index].dateCreated, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      });
      result.staff.staffRecords.sort((a: any, b: any) =>
        a.staffName.localeCompare(b.staffName)
    );
      result.taxAgent.taxAgentRecords.forEach((currentValue: any, index: any) => {
        result.taxAgent.taxAgentRecords[index].licenseStart = formatDate(result.taxAgent.taxAgentRecords[index].licenseStart, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.taxAgent.taxAgentRecords[index].licenseEnd = formatDate(result.taxAgent.taxAgentRecords[index].licenseEnd, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      });
      result.taxAgent.taxAgentRecords.sort((a: any, b: any) =>
        a.taxAgentName.localeCompare(b.taxAgentName)
    );
      this.staffDataSource = new MatTableDataSource(result.staff.staffRecords);
      this.taxagentDataSource = new MatTableDataSource(result.taxAgent.taxAgentRecords);
      
      this.NotTaxAgentSearchStatus = result.staff.totalStaff === 0 ? false : true;
      this.TaxAgentSearchStatus = result.taxAgent.totalTaxAgent === 0 ? false : true;
      this.LoaderStatus = false;
    }
  }

  async GetDataStaff(IDNo:any, FirmID:any, PageNum:any, PageSize:any){
    this.LoaderStatus = true;
    let Params = {};
    if (IDNo === "" || IDNo === null) {
      Params = {
        "FirmID": FirmID,
        "StaffList": true,
        "AgentList": false,
        "PageNum": PageNum ?? 0,
        "PageSize": PageSize ?? 5
      }
    } else {
      Params = {
        "FirmID": FirmID,
        "IDNo": IDNo,
        "StaffList": true,
        "AgentList": false,
        "PageNum": PageNum ?? 0,
        "PageSize": PageSize ?? 5
      }
    }
    const result = await this.apiServices.GetAllStaff(Params);
    
    result.staff.staffRecords.forEach((currentValue: any, index: any) => {
      switch (result.staff.staffRecords[index].role) {
        case "0201":
          result.staff.staffRecords[index].role = "Pentadbir";
          break;
        case "0202":
          result.staff.staffRecords[index].role = "Penyelia";
          break;
        case "0203":
          result.staff.staffRecords[index].role = "Staf";
          break;
        default:
          break;
      }
      result.staff.staffRecords[index].firmUserEmail = result.staff.staffRecords[index].firmUserEmail === null ? "N/A" : result.staff.staffRecords[index].firmUserEmail;
      result.staff.staffRecords[index].dateCreated = formatDate(result.staff.staffRecords[index].dateCreated, 'dd-MMM-yyyy h:mm:ss a', "en-US");
    });
    result.staff.staffRecords.sort((a: any, b: any) =>
        a.staffName.localeCompare(b.staffName)
    );
    this.StaffRecordCount = result.staff.totalStaff;
    this.staffDataSource = new MatTableDataSource(result.staff.staffRecords);
    this.NotTaxAgentSearchStatus = result.staff.totalStaff === 0 ? false : true;
    this.LoaderStatus = false;
  }

  async GetDataTaxAgent(IDNo:any, FirmID:any, PageNum:any, PageSize:any){
    this.LoaderStatus = true;
    let Params = {};
    if (IDNo === "" || IDNo === null) {
      Params = {
        "FirmID": FirmID,
        "StaffList": false,
        "AgentList": true,
        "OggFilter": true,
        "ActiveIndFilter": true,
        "PageNum": PageNum ?? 0,
        "PageSize": PageSize ?? 5
      }
    } else {
      Params = {
        "FirmID": FirmID,
        "IDNo": IDNo,
        "StaffList": false,
        "AgentList": true,
        "OggFilter": true,
        "ActiveIndFilter": true,
        "PageNum": PageNum ?? 0,
        "PageSize": PageSize ?? 5
      }
    }
    
    const result = await this.apiServices.GetAllStaff(Params);
    
    result.taxAgent.taxAgentRecords.forEach((currentValue: any, index: any) => {
      result.taxAgent.taxAgentRecords[index].licenseStart = formatDate(result.taxAgent.taxAgentRecords[index].licenseStart, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      result.taxAgent.taxAgentRecords[index].licenseEnd = formatDate(result.taxAgent.taxAgentRecords[index].licenseEnd, 'dd-MMM-yyyy h:mm:ss a', "en-US");
    });
    result.taxAgent.taxAgentRecords.sort((a: any, b: any) =>
        a.taxAgentName.localeCompare(b.taxAgentName)
    );
    this.TaxAgentRecordCount = result.taxAgent.totalTaxAgent;
    this.taxagentDataSource = new MatTableDataSource(result.taxAgent.taxAgentRecords);
    this.TaxAgentSearchStatus = result.taxAgent.totalTaxAgent === 0 ? false : true;
    this.LoaderStatus = false;
  }

  Semula(){
    this.LoaderStatus = false;
    this.TaxAgentSearchStatus = false;
    this.NotTaxAgentSearchStatus = false;

    this.IDNoInput = "";
    this.StaffFirmUserEmailInput = "";
    this.IDNoView = "";

    this.staffDataSource = new MatTableDataSource();
    this.taxagentDataSource = new MatTableDataSource();

    this.TaxAgentRecordCount = "";
    this.StaffRecordCount = "";

    this.TaxAgentIDView = "";
    this.TaxAgentIDNoView = "";
    this.TaxAgentNameView = "";
    this.StaffIDView = "";
    this.StaffIDNoView = "";
    this.StaffNameView = "";
    this.StaffRoleView = "";
    this.GetData("", this.FirmIDView, 0, 5);
  }

  GotoDetailPage(){
    this.router.navigate(['/butiran-daftar-kemaskini']);
  }

  ResetValue(){
    this.LoaderStatus = false;
    this.TaxAgentSearchStatus = false;
    this.NotTaxAgentSearchStatus = false;

    this.IDNoView = "";

    this.staffDataSource = new MatTableDataSource();
    this.taxagentDataSource = new MatTableDataSource();

    this.TaxAgentRecordCount = "";
    this.StaffRecordCount = "";

    this.TaxAgentIDView = "";
    this.TaxAgentIDNoView = "";
    this.TaxAgentNameView = "";
    this.StaffIDView = "";
    this.StaffIDNoView = "";
    this.StaffNameView = "";
    this.StaffRoleView = "";
  }

  ViewUpdateTaxAgent(StaffID: any, TaxAgentID: any, TaxAgentIDNo: any, TaxAgentName: any, TaxAgentApprovalNo: any, TaxAgentCertStart: any, TaxAgentCertEnd: any, TaxAgentEmail: any, TaxAgentPhoneNo: any, FirmUserEmail: any, FirmUserStatus:any) {
    this.TaxAgentStaffIDView = StaffID;
    this.TaxAgentIDView = TaxAgentID;
    this.TaxAgentIDNoView = TaxAgentIDNo;
    this.TaxAgentNameView = TaxAgentName;
    this.TaxAgentApprovalNo = TaxAgentApprovalNo;
    this.TaxAgentEmail = TaxAgentEmail;
    this.TaxAgentCertStartView = TaxAgentCertStart;
    this.TaxAgentCertEndView = TaxAgentCertEnd;
    this.TaxAgentPhoneNoView = TaxAgentPhoneNo;
    this.TaxAgentFirmUserEmailInput = FirmUserEmail;
    this.TaxAgentFirmUserStatus = FirmUserStatus;
  }

  async UpdateTaxAgent(StaffID: any, FirmID: any, FirmUserEmail: any,FirmUserStatus:any) {
    this.LoaderStatus = true;
    const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (FirmUserEmail === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else if (!expression.test(FirmUserEmail)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan emel mengikut format yang betul.";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.agentUpdateCloseButton.nativeElement.click();
      let tempStatus = FirmUserStatus === "true" || FirmUserStatus === true ? true : false;
      let Params = {
        "AdminID": this.SessionStaffID,
        "StaffID": StaffID,
        "FirmID": FirmID,
        "EjenID": this.TaxAgentIDView,
        "Role": "0204",
        "FirmUserEmail": FirmUserEmail,
        "Status": tempStatus
      }
      const result = await this.apiServices.UpdateStaff(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.GetDataTaxAgent(this.IDNoView, this.FirmIDView, this.TaxAgentDataTablePageNum, this.TaxAgentDataTablePageSize);
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      }
    }
  }

  ViewUpdateStaff(StaffID: any, StaffName: any, StaffIDNo: any, StaffRole: any, FirmUserEmail: any, FirmUserStatus: boolean) {
    
    this.StaffOldRoleView = StaffRole === "Pentadbir" ? "0201" : (StaffRole === "Penyelia" ? "0202" : (StaffRole === "Staf" ? "0203" : "0204"));
    this.StaffRoleView = StaffRole === "Pentadbir" ? "0201" : (StaffRole === "Penyelia" ? "0202" : (StaffRole === "Staf" ? "0203" : "0204"));
    this.StaffIDView = StaffID;
    this.StaffIDNoView = StaffIDNo;
    this.StaffNameView = StaffName;
    this.StaffFirmUserEmailInput = FirmUserEmail;
    this.StaffFirmUserStatus = FirmUserStatus;
  }

  onChange() {
    if (this.StaffRoleView === this.StaffOldRoleView)
      this.UpdateRole = false;
    else
      this.UpdateRole = true;
  }

  async UpdateStaff(StaffID: any, FirmID:any, StaffRole: any, FirmUserEmail:any, FirmUserStatus:any) {
    this.LoaderStatus = true;
    const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (FirmUserEmail === "" || StaffRole === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else if (!expression.test(FirmUserEmail)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan emel mengikut format yang betul.";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.staffUpdateCloseButton.nativeElement.click();
      let tempStatus = FirmUserStatus === "true" || FirmUserStatus === true ? true : false;
      let Params = {
        "AdminID": this.SessionStaffID,
        "StaffID": StaffID,
        "FirmID": FirmID,
        "Role": StaffRole,
        "FirmUserEmail": FirmUserEmail,
        "Status": tempStatus
      }
      const result = await this.apiServices.UpdateStaff(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.GetDataStaff(this.IDNoView, this.FirmIDView, this.StaffDataTablePageNum, this.StaffDataTablePageSize);
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      }
    }
  }

  TaxAgentDeleteView(StaffID:any,TaxAgentID: any, TaxAgentIDNo: any, TaxAgentName: any) {
    this.StaffIDView = StaffID;
    this.TaxAgentIDView = TaxAgentID;
    this.TaxAgentIDNoView = TaxAgentIDNo;
    this.TaxAgentNameView = TaxAgentName;
  }

  StaffDeleteView(StaffID:any, StaffIDNo:any, StaffName:any,Role:any) {
    this.StaffIDView = StaffID;
    this.StaffRoleView = Role;
    this.StaffIDNoView = StaffIDNo;
    this.StaffNameView = StaffName;
  }

  async StaffDeleteSubmit(StaffID: any, TaxAgentID: any, Role: any) {
    this.LoaderStatus = true;
    switch (Role) {
      case "Pentadbir":
        Role = "0201";
        break;
      case "Penyelia":
        Role = "0202";
        break;
      case "Staf":
        Role = "0203";
        break;
    }
    const result = await this.apiServices.DeleteStaff(StaffID, TaxAgentID, this.FirmIDView, Role, this.SessionStaffID);
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.GetDataStaff("", this.FirmIDView, this.StaffDataTablePageNum, this.StaffDataTablePageSize);
      this.AlertType = "success";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    }
  }
  async AgentDeleteSubmit(StaffID: any, TaxAgentID: any, Role: any) {
    this.LoaderStatus = true;
    const result = await this.apiServices.DeleteStaff(StaffID, TaxAgentID, this.FirmIDView, Role, this.SessionStaffID);
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.GetDataTaxAgent("", this.FirmIDView, this.TaxAgentDataTablePageNum, this.TaxAgentDataTablePageSize);
      this.AlertType = "success";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    }
  }
  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }
}
